// This file is auto-generated.
// It's responsible for giving the view it's own Flow context.

import { Flow } from 'Simple/Flow'
import React from 'react'
import ReportTable from './view'

export default function ReportTableFlow({ children, ...props }) {
  return (
    <Flow viewPath={props.viewPath} flowDefinitionViewPathSource="/DesignSystem/Report/ReportTable">
      <ReportTable {...props}>
        {children}
      </ReportTable>
    </Flow>
  )
}
